/**
 * @memberof app
 * @ngdoc filter
 * @name arrayToTags
 */

(function() {
    'use strict';

    angular.module('app').filter('arrayToTags', function() {
        /**
         * @func arrayToTagsFilter
         * @memberof arrayToTags
         * @param {Object} obj
         * @desc returns array in format readable by ng-model for tags-input directive
         */
        return function (obj) {
            var tags = [];
            for(var i in obj.length){
                tags.push({
                    text: obj[i]
                });
            };
            return tags;
        };
    });

}());